import clsx from 'clsx';
import HelperText from './shared/HelperText';
import ErrorText from './shared/ErrorText';
import {Checkbox} from '@/shadcn_components/ui/checkbox';
import {InputProps, useInput} from '@/hooks/useInput';

export type CheckboxInputProps = InputProps & Partial<React.ComponentProps<'div'>>;

const CheckboxInput = (props: CheckboxInputProps) => {
  const {
    field: {value, onChange},
    fieldState,
  } = useInput(props);
  // const translate = useTranslate();
  const {className} = props;

  return (
    <div className={clsx('form-control w-full', className)}>
      <div className="flex flex-row items-center">
        <Checkbox
          checked={Boolean(value)}
          onCheckedChange={ch => onChange(Boolean(ch))}
          id={props.source}
        />
        <label className="pl-2" htmlFor={props.source}>
          {props.label}
        </label>
      </div>
      <HelperText helperText={props.helperText} />
      <ErrorText {...fieldState} />
    </div>
  );
};

export default CheckboxInput;
